import React from 'react';
import styles from './styles/base.module.css';
export const InputLabel = ({
  label,
  ...props
}) => {
  var _props$dataTestid;
  const testId = (_props$dataTestid = props['data-testid']) != null ? _props$dataTestid : 'label';
  if (label) {
    return /*#__PURE__*/React.createElement("legend", {
      "data-testid": `${testId}-input-label`,
      className: styles.inputLegend
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.inputLegendSpan
    }, " ", label));
  }
  return null;
};